import React from 'react'
import './styles.css'
import HotelSearchEngine from '../../HotelSearchEngine/HotelSearchEngine'
import FilterAsideHotels from './FilterAsideHotels/FilterAsideHotels'

const AsideHotelResult = ({ setFirstRange, setSecondRange, activeFilterPrice, setActiveFilterPrice, erroFilter, setResetResult, resetResult }) => {
  return (
    <div className='contain-aside-hotel-result'>
      <HotelSearchEngine titleSize={'20px'} iconTitleSize={'50'} containDateFlexDirection={'column'} containDateJustify={'space-between'} layoutCampoWidth={'100%'} containFinishFlexDirection={'column'} containFinishJustify={'space-between'} layoutCampoVWidth={'100%'} widthContain={'100%'} />

      <FilterAsideHotels
        widthContain={'100%'}
        setSecondRange={setSecondRange}
        activeFilterPrice={activeFilterPrice}
        errorFilter={erroFilter}
        setActiveFilterPrice={setActiveFilterPrice}
        setFirstRange={setFirstRange} 
         setResetResult={setResetResult}
        resetResult={resetResult}
        />
     
    </div>
  )
}

export default AsideHotelResult